import type { MediaType } from "./movies";

export interface CategoryMeta {
  key: MediaType;
  name: string;
  english: string;
  icon: string;
  description: string;
  accent: string;
}

export const categories: CategoryMeta[] = [
  {
    key: "movie",
    name: "电影",
    english: "Movies",
    icon: "ri-film-line",
    description: "院线新片、经典重映与独立佳作，按口碑与热度精选。",
    accent: "bg-primary-500",
  },
  {
    key: "tv",
    name: "电视剧",
    english: "Series",
    icon: "ri-live-line",
    description: "国产剧、美剧、韩剧与英剧，追更不落下一集。",
    accent: "bg-accent-500",
  },
  {
    key: "variety",
    name: "综艺",
    english: "Variety",
    icon: "ri-mic-line",
    description: "音乐、喜剧、旅行与真人秀，轻松时刻一键直达。",
    accent: "bg-secondary-500",
  },
  {
    key: "anime",
    name: "动画",
    english: "Anime",
    icon: "ri-magic-line",
    description: "新番、国漫与动画电影，画面与故事都不将就。",
    accent: "bg-primary-400",
  },
];

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
  anime: "动画",
};

export const categoryDescription: Record<MediaType, string> = {
  movie: "从院线热映到口碑佳作，色虎电影频道为你整理每一部值得走进影院的影片，涵盖悬疑、科幻、剧情与爱情等类型。",
  tv: "国产剧、海外剧与短剧集一网打尽，按口碑、热度与更新时间筛选，找到下一部想一口气看完的剧。",
  variety: "音乐竞技、喜剧舞台与治愈慢综艺，按热度和评分排序，发现适合下饭与周末放松的节目。",
  anime: "日本新番、国产动画与动画电影，追更、补番与画面党推荐都在这里。",
};

export const heroSlides = [
  {
    movieId: "wudu-mian",
    kicker: "本周口碑榜首",
    title: "雾都谜案",
    subtitle: "全 12 集 · 年代悬疑",
    description: "一桩码头沉尸案，牵出整座城市心照不宣的秘密。",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%201930s%20harbor%20city%20at%20night%20vintage%20streetlamps%20reflecting%20on%20wet%20stone%20deep%20navy%20blue%20mist%20with%20warm%20amber%20highlights%20film%20grain&width=1600&height=900&seq=hero-wudu&orientation=landscape",
    rating: 8.8,
  },
  {
    movieId: "xinghai-huisheng",
    kicker: "年度科幻巨制",
    title: "星海回声",
    subtitle: "152 分钟 · 深空科幻",
    description: "当求救信号来自你自己，你还敢确认自己是归来者吗？",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20space%20scene%20with%20an%20astronaut%20silhouette%20facing%20a%20vast%20glowing%20nebula%20deep%20navy%20black%20space%20with%20soft%20orange%20starlight%20epic%20scale%20film%20grain&width=1600&height=900&seq=hero-xinghai&orientation=landscape",
    rating: 8.9,
  },
  {
    movieId: "yunhai-zhishang",
    kicker: "新番高分推荐",
    title: "云海之上",
    subtitle: "更新至第 8 话 · 奇幻冒险",
    description: "少女与一艘会随风思考的旧船，驶向只存在于风里的故乡。",
    backdrop:
      "https://readdy.ai/api/search-image?query=hand%20painted%20anime%20wide%20scene%20of%20a%20small%20wooden%20flying%20boat%20above%20an%20endless%20sea%20of%20clouds%20deep%20navy%20sky%20with%20warm%20orange%20sunrise%20glow%20cinematic%20composition&width=1600&height=900&seq=hero-yunhai&orientation=landscape",
    rating: 9.0,
  },
  {
    movieId: "shaqiu-zhiwai",
    kicker: "正在热映",
    title: "沙丘之外",
    subtitle: "164 分钟 · 沙漠史诗",
    description: "他们要证明的不是传说，而是人仍愿意为答案走很远。",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20desert%20epic%20scene%20lone%20traveler%20on%20a%20golden%20dune%20under%20a%20vast%20deep%20blue%20sky%20sand%20haze%20warm%20orange%20dust%20light%20epic%20minimal%20composition&width=1600&height=900&seq=hero-shaqiu&orientation=landscape",
    rating: 8.1,
  },
];

export const regions = ["全部地区", "中国大陆", "中国香港", "中国台湾", "美国", "日本", "韩国", "英国"];

export const years = ["全部年份", "2025", "2024", "2023"];

export const genreOptions = [
  "全部类型",
  "剧情",
  "悬疑",
  "犯罪",
  "科幻",
  "爱情",
  "喜剧",
  "动作",
  "奇幻",
  "冒险",
  "家庭",
  "古装",
  "真人秀",
  "治愈",
];

export const sortOptions = [
  { key: "heat", label: "按热度" },
  { key: "newest", label: "按最新" },
  { key: "rating", label: "按评分" },
] as const;

export const newsCategories = ["全部", "新闻", "影评", "专题", "预告"] as const;

export const siteStats = [
  { label: "影视作品", value: "28 部" },
  { label: "影视资讯", value: "16 篇" },
  { label: "合作片方", value: "40+" },
  { label: "每日更新", value: "12 条" },
];